import mapboxgl from "mapbox-gl";
import { createApp } from "vue";
import router from "./router.js";
import { ui } from "vutil";
import { vmap } from "vmap";
import App from "./App.vue";

mapboxgl.accessToken = "pk.eyJ1IjoicmljaGFhcyIsImEiOiJjazhjeGFmYmUwbzZ6M2trYXZrd2Uwemc1In0.qkMjwNRxrOJMKjrX3WmKzg";

const app = createApp(App);

app.use(router);
app.use(ui);
app.use(vmap);

app.mount("#app");
